import ENV_PARAMS from '@/constants/envParams'

export enum PreferredExplorer {
  Solscan = 'https://solscan.io',
  SolanaBeach = 'https://solanabeach.io',
  SolanaExplorer = 'https://explorer.solana.com',
  SolanaFm = 'https://solana.fm',
  OKLink = 'https://www.oklink.com'
}
export const TX_URL = {
  [PreferredExplorer.Solscan]: PreferredExplorer.Solscan + '/tx/',
  [PreferredExplorer.SolanaBeach]:
    PreferredExplorer.SolanaBeach + '/transaction/',
  [PreferredExplorer.SolanaExplorer]: PreferredExplorer.SolanaExplorer + '/tx/',
  [PreferredExplorer.SolanaFm]: PreferredExplorer.SolanaFm + '/tx/',
  [PreferredExplorer.OKLink]: PreferredExplorer.OKLink + '/sol/tx/'
}
export const ACCOUNT_URL = {
  [PreferredExplorer.Solscan]: PreferredExplorer.Solscan + '/account/',
  [PreferredExplorer.SolanaBeach]: PreferredExplorer.SolanaBeach + '/address/',
  [PreferredExplorer.SolanaExplorer]:
    PreferredExplorer.SolanaExplorer + '/address/',
  [PreferredExplorer.SolanaFm]: PreferredExplorer.SolanaFm + '/address/',
  [PreferredExplorer.OKLink]: PreferredExplorer.OKLink + '/sol/account/'
}

export const SUPPORT_PREFERRED_EXPLORER = [
  {
    name: 'Solscan',
    url: PreferredExplorer.Solscan
  },
  {
    name: 'SolanaBeach',
    url: PreferredExplorer.SolanaBeach
  },
  {
    name: 'SolanaExplorer',
    url: PreferredExplorer.SolanaExplorer
  },
  {
    name: 'SolanaFm',
    url: PreferredExplorer.SolanaFm
  },
  {
    name: 'OKLink',
    url: PreferredExplorer.OKLink
  }
]

export const DEFAULT_PREFERRED_EXPLORER = SUPPORT_PREFERRED_EXPLORER[0]

export enum RPCEndpointKey {
  Custom = 'Custom',
  QuiknodeRPC = 'QuiknodeRPC',
  HeliusRPC = 'HeliusRPC',
  // TritonRPCPool1 = 'TritonRPCPool1',
  // TritonRPCPool2 = 'TritonRPCPool2'
}


export const SUPPORT_RPC_ENDPOINT = [
  {
    name: 'Helius RPC',
    url: ENV_PARAMS.HELIUS_RPC_URL,
    ws: ENV_PARAMS.HELIUS_RPC_WSS,
    key: RPCEndpointKey.HeliusRPC,
    mev: false
  },
  {
    name: 'Quiknode RPC',
    url: ENV_PARAMS.QUIKNODE_RPC_URL,
    ws: ENV_PARAMS.QUIKNODE_RPC_WSS,
    key: RPCEndpointKey.QuiknodeRPC,
    mev: true
  },
  {
    name: 'Custom',
    url: '',
    ws: '',
    key: RPCEndpointKey.Custom,
    mev: false
  }
]

export const DEFAULT_RPC_ENDPOINT = SUPPORT_RPC_ENDPOINT[0]

export enum TransactionBroadcasting {
  PriorityFee = 'PriorityFee',
  // JitoOnly = 'JitoOnly',
  Mixed = 'Mixed'
}

export const SUPPORT_TRANSACTION_BROADCASTING = [
  {
    label: 'PriorityFee',
    value: TransactionBroadcasting.PriorityFee
  },
  // {
  //   label: 'JitoOnly',
  //   value: TransactionBroadcasting.JitoOnly
  // },
  {
    label: 'Mixed',
    value: TransactionBroadcasting.Mixed
  }
]

export const DEFAULT_TRANSACTION_BROADCASTING =
  SUPPORT_TRANSACTION_BROADCASTING[0]

export enum FeeMode {
  MaxCap = 'MaxCap',
  ExactFee = 'ExactFee'
}

export const SUPPORT_FEE_MODE = [
  {
    label: 'Max Cap',
    value: FeeMode.MaxCap
  },
  {
    label: 'Exact Fee',
    value: FeeMode.ExactFee
  }
]

export enum PriorityFeeLevel {
  Fast = 'Fast',
  Turbo = 'Turbo',
  Ultra = 'Ultra'
}

export const PRIORITY_FEE_LEVEL = [
  {
    label: 'Fast',
    value: PriorityFeeLevel.Fast
  },
  {
    label: 'Turbo',
    value: PriorityFeeLevel.Turbo
  },
  {
    label: 'Ultra',
    value: PriorityFeeLevel.Ultra
  }
]

export const SLIPPAGE_OPTIONS = ['10', '15', '50']

export const TOKEN_MARKET_CAP_SOL = 85000000000
export const DEFAULT_PRIORITY_FEE_MODE = SUPPORT_FEE_MODE[0]
export const DEFAULT_PRIORITY_FEE_LEVEL = PRIORITY_FEE_LEVEL[0]
export const DEFAULT_PRIORITY_FEE_VALUE = '0.005'
export const DEFAULT_SLIPPAGE_VALUE = SLIPPAGE_OPTIONS[1]
export const DEFAULT_MEV_STATE = false
export const DEFAULT_COMPUTE_UNIT_LIMIT = 550000

export interface ITxSettingProps {
  txBroadcast: string
  feeLevel: string
  feeMode: string
  feeValue: string
  slippage: string
  mevState: boolean
}
export const DEFAULT_TRANSACTION_SETTING: ITxSettingProps = {
  txBroadcast: DEFAULT_TRANSACTION_BROADCASTING.value,
  feeLevel: DEFAULT_PRIORITY_FEE_LEVEL.value,
  feeMode: DEFAULT_PRIORITY_FEE_MODE.value,
  feeValue: DEFAULT_PRIORITY_FEE_VALUE,
  slippage: DEFAULT_SLIPPAGE_VALUE,
  mevState: DEFAULT_MEV_STATE
}
